module.exports = __webpack_public_path__ + "static/UNITY-TOWER-1st-floor-modern_v2-en-a7efc4af2e93b3969729b8f59274eea4.pdf";